export const tipoDocumentos = [
    { value: '1', text: 'Cédula' },
    { value: '2', text: 'Pasaporte' },
    { value: '3', text: 'Residencia' },
]